import { useState, useEffect } from "react";
import { getLive } from "../../network/lib/upakram.js";
import { handleContent } from "../utils/helper.js";
import parse from "html-react-parser";
import hallBackImg from "../../assests/images/hall/Hall26.jpg";

function Upakram() {
  const [upakramDetails, setUpakramDetails] = useState();

  useEffect(() => {
    !upakramDetails && populateUpakramDetails();
  }, []);

  function populateUpakramDetails() {
    getLive().then((res) => {
      if (res.status == 200) {
        setUpakramDetails(res.data);
      }
    });
  }

  const contents = upakramDetails && (
    <div className="Row">
      <div className="Cell" style={{ textAlign: "left", backgroundImage: `url(${hallBackImg})`,border: '3px solid #fe6902', borderRadius: '40px', 
                                backgroundRepeat: 'repeat-y',backgroundPosition :'right', padding:"10px 25px" }}>
        <div style={ { paddingLeft: '10px', color: 'black',} }>
          <table
            cellSpacing="0"
            style={{ width: "797px", borderCollapse: "collapse" }}
          >
            <tbody>
              <tr>
                <th scope="col">&nbsp;</th>
              </tr>
              {upakramDetails.map((upakramDetail) => (
                <tr key={upakramDetail.id}>
                  <td>
                    {parse(
                      `<span class="headings">${upakramDetail.heading}</span>`
                    )}
                    {upakramDetail.image &&
                      parse(
                        `<img src=${upakramDetail.image} style="float: right;width: 350px"/>`
                      )}
                    {parse(
                      handleContent(
                        upakramDetail.contentTypeId,
                        upakramDetail.content
                      )
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );

  return contents;
}

export default Upakram;
